/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Content_ResearchInputs */

const en_onboarding_content_research = /** @type {(inputs: Onboarding_Content_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research papers`)
};

const es_onboarding_content_research = /** @type {(inputs: Onboarding_Content_ResearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos de investigación`)
};

/**
* | output |
* | --- |
* | "Research papers" |
*
* @param {Onboarding_Content_ResearchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_content_research = /** @type {((inputs?: Onboarding_Content_ResearchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Content_ResearchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_content_research(inputs)
	return en_onboarding_content_research(inputs)
});